import { asperaSdk } from '../index';
import { errorLog, generateErrorBody, generatePromiseObjects, getCurrentPlatform, isValidURL, throwError } from '../helpers/helpers';
import { apiGet } from '../helpers/http';
import { messages } from '../constants/messages';
/**
 * Get the latest Aspera SDK installer information such as download URL and version.
 *
 * @param options Installer info options
 *
 * @returns a promise that resolves with the installer info and rejects if there is an error
 */
export var getInstallerInfo = function (options) {
    if (options === void 0) { options = {}; }
    var url = options.endpoint || asperaSdk.globals.installerUrl;
    if (url.endsWith('/latest.json')) {
        url = url.replace('/latest.json', '');
    }
    if (!isValidURL(url)) {
        return throwError(messages.invalidEndpoint, { url: url });
    }
    var promiseInfo = generatePromiseObjects();
    apiGet("".concat(url, "/latest.json")).then(function (response) {
        response.json().then(function (data) {
            if (options.endpoint) {
                for (var _i = 0, _a = data.entries; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    if (!isValidURL(entry.url)) {
                        entry.url = "".concat(options.endpoint, "/").concat(entry.url);
                    }
                }
            }
            if (options.all) {
                promiseInfo.resolver(data);
            }
            else {
                var platform_1 = getCurrentPlatform();
                data.entries = data.entries.filter(function (entry) { return entry.platform === platform_1; });
                promiseInfo.resolver(data);
            }
        });
    }).catch(function (error) {
        errorLog(messages.getInstallerError, error);
        promiseInfo.rejecter(generateErrorBody(messages.getInstallerError, error));
    });
    return promiseInfo.promise;
};
